import { Footer } from './Footer';

export type { TypeFooterProps } from './types';
export default Footer;
